import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const AgencyTickets = lazy(() => import('../../../../main/agency/tickets/AgencyTicketsPage'));

const TicketDetails = lazy(() => import('../../../../main/common/tickets/ticket-details/TicketDetails'));

const TicketDescription = lazy(
  () => import('app/main/common/tickets/ticket-details/components/ticket-description/TicketDescription')
);
const TicketComments = lazy(
  () => import('app/main/common/tickets/ticket-details/components/ticket-comments/TicketComments')
);

export const agencyTicketsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense fallback={<DataLoader />}>
        <AgencyTickets />
      </Suspense>
    ),
  },
  {
    path: ':ticketId',
    element: (
      <Suspense fallback={<DataLoader />}>
        <TicketDetails viewType="agency" />
      </Suspense>
    ),
    children: [
      {
        path: '',
        element: <Navigate replace to="details" />,
      },
      {
        path: 'details',
        element: (
          <Suspense fallback={<DataLoader />}>
            <TicketDescription />
          </Suspense>
        ),
      },
      {
        path: 'comments',
        element: (
          <Suspense fallback={<DataLoader />}>
            <TicketComments />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Error404Page />,
  },
  {
    path: ':any/*',
    element: <Error404Page />,
  },
];
